import classNames from 'classnames';
import { TourType } from '@/_models/Tour';
import { toggleContactPopup } from '../util';
import DeviceManager from '../util/deviceManager';

export function renderButtonBg() {
  const { tour, room, menuOpen, host, translation, tourEmail, tourType } = this.state;
  const menuOpenForDevice = !!(DeviceManager.isMobile() ? tour.menuAlwaysOpenMobile : tour.menuAlwaysOpenDesktop);
  const showExpand = !this.state.menuOpened && !tour.menuOnStart;
  const showCustomButton = tour.customButton && tour.customButtonIcon && tourType === TourType.Regular;

  return (
    <div className={menuOpen ? 'buttonsBg open' : 'buttonsBg'}>
      {(!room || (room && host)) && tour.menuEnabled && !menuOpenForDevice && tourType !== TourType.Game && (
        <div>
          {tour.menuTooltipOn && this.state.MenuHintOn && (
            <div className="appointment-hint">
              <i
                className="fas fa-times fa-times-hint-icon"
                onClick={() => {
                  this.setState({
                    MenuHintOn: false,
                  });
                }}
              />
              <span>{(translation && translation.menuAppointmentTooltip) || 'Menu'}</span>
              <i className="fas fa-arrow-right fa-arrow-right-hint-icon" />
            </div>
          )}
          <div className={classNames('buttonBg', showExpand && 'expand')} onClick={this.toggleNav.bind(this)}>
            <button className={menuOpen ? 'hamburger hamburger--spin is-active' : 'hamburger hamburger--spin'} type="button">
              <span className="hamburger-box">
                <span className="hamburger-inner" />
              </span>
            </button>
          </div>
        </div>
      )}
      {!room && (
        <div>
          {tour.contactForm && ((tour.client && tour.client.email) || tourEmail?.menuGetInTouch) && !tour.menuEnabled && tourType !== TourType.Game && (
            <div className="appointment-btn-container">
              {tour.getInTouchTooltipOn && this.state.getInTouchHintOn && (
                <div className="appointment-hint">
                  <i
                    className="fas fa-times fa-times-hint-icon"
                    onClick={() => {
                      this.setState({
                        getInTouchHintOn: false,
                      });
                    }}
                  />
                  <span>{(translation && translation.getInTouchAppointmentTooltip) || 'Get in touch'}</span>
                  <i className="fas fa-arrow-right fa-arrow-right-hint-icon" />
                </div>
              )}
              <a
                className="buttonBg"
                onClick={() => {
                  this.setState({ getInTouchHintOn: false });
                  toggleContactPopup.call(this);
                }}
              >
                <i className="fas fa-address-card" />
              </a>
            </div>
          )}
          {tour.appointmentsOn && !this.state.menuOpen && tourType !== TourType.Game && (
            <div className="appointment-btn-container">
              {this.state.appointmentsHintOn && (
                <div className="appointment-hint">
                  <i
                    className="fas fa-times fa-times-hint-icon"
                    onClick={() => {
                      this.setState({
                        appointmentsHintOn: false,
                      });
                    }}
                  />
                  <span>{translation && translation.videoAppointmentTooltip}</span>
                  <i className="fas fa-arrow-right fa-arrow-right-hint-icon" />
                </div>
              )}
              <a className="buttonBg active" onClick={this.toggleAppointmentsModal}>
                <i className="fas fa-calendar-alt" />
              </a>
            </div>
          )}
          {showCustomButton && (
            <div className="appointment-btn-container">
              <a className="buttonBg" onClick={this.handleCustomButton}>
                <img className="custom-button" src={`${process.env.REACT_APP_AWS}/tours/${tour.id}/${tour.customButtonIcon}`} alt="" />
              </a>
            </div>
          )}
        </div>
      )}
      {this.injectBottomBg()}
    </div>
  );
}
